export const URL = "https://Shopping-cart-server-github.rupamdas.repl.co"